/** Screen-space drag threshold before a pointer-up counts as a marquee drag (not a click). */
export const TEXT_DRAG_THRESHOLD_SCREEN_PX = 6

/** Minimum marquee width/height in screen pixels to create a text box. */
export const TEXT_BOX_MIN_DIMENSION_SCREEN_PX = 10

/** Convert a screen-pixel threshold to canvas coordinates at the given zoom scale. */
export function screenPxToCanvasPx(screenPx: number, scale: number): number {
  if (!Number.isFinite(scale) || scale <= 0) return screenPx

  return screenPx / scale
}

export function meetsTextDragThreshold(dxCanvas: number, dyCanvas: number, scale: number): boolean {
  const threshold = screenPxToCanvasPx(TEXT_DRAG_THRESHOLD_SCREEN_PX, scale)

  return Math.abs(dxCanvas) >= threshold || Math.abs(dyCanvas) >= threshold
}

/** Scale-aware drag threshold for marquee / pointer gestures (6 screen px). */
export function pointerDragThresholdCanvas(scale: number): number {
  return screenPxToCanvasPx(TEXT_DRAG_THRESHOLD_SCREEN_PX, scale)
}

export function meetsTextBoxMinDimensions(
  widthCanvas: number,
  heightCanvas: number,
  scale: number
): boolean {
  const min = screenPxToCanvasPx(TEXT_BOX_MIN_DIMENSION_SCREEN_PX, scale)

  return widthCanvas >= min && heightCanvas >= min
}

export function clampTextBoxDimensions(
  widthCanvas: number,
  heightCanvas: number,
  scale: number
): { width: number; height: number } {
  const min = screenPxToCanvasPx(TEXT_BOX_MIN_DIMENSION_SCREEN_PX, scale)

  return {
    width: Math.max(min, widthCanvas),
    height: Math.max(min, heightCanvas),
  }
}
